import * as actionTypes from 'modules/checklists/actionTypes';
import type { DeleteChecklistSuccessAction, SearchChecklistsSuccessAction } from 'modules/checklists/types';
import type { Action } from 'modules/global/generic.types';
import { isSuccessRequest } from 'modules/global/reducers/utils';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistUiDashboardIds = Array<string>;

const initialState: ChecklistUiDashboardIds = [];

export const mainDashboardConfig = { matcher: ({ meta }: Action) => meta?.source === undefined };

const afterFetchChecklists = (_: ChecklistUiDashboardIds, { payload }: SearchChecklistsSuccessAction): ChecklistUiDashboardIds =>
  payload.content.map(({ id }) => id);

const deleteChecklist = (
  state: ChecklistUiDashboardIds,
  { payload: checklistId }: DeleteChecklistSuccessAction
): ChecklistUiDashboardIds => state.filter(id => id !== checklistId);

const reset = (): ChecklistUiDashboardIds => initialState;

export default createReducer(
  initialState,
  {
    [actionTypes.CLEAN_CHECKLISTS]: reset,
    [actionTypes.DELETE_CHECKLIST_SUCCESS]: deleteChecklist,
  },
  [{ matcher: isSuccessRequest(actionTypes.SEARCH_CHECKLISTS_REQUEST, mainDashboardConfig), reducer: afterFetchChecklists }]
);
